// extracted by mini-css-extract-plugin
module.exports = {"button":"node_modules-@otpusk-tourscaner-dist-components-Results-components-Hotel-components-OpenOfferButton-styles__button"};